/**
 * @generated SignedSource<<55bc2cfdce0149b6ef6eea1b6e4ed615>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserPrimaryPhotoNew_user$data = {
  readonly defaultAvatarUrl: string;
  readonly emailMd5: string | null | undefined;
  readonly firstName: string;
  readonly lastName: string;
  readonly primaryPhoto: {
    readonly transformUrl: string;
  } | null | undefined;
  readonly rowId: string;
  readonly " $fragmentType": "UserPrimaryPhotoNew_user";
};
export type UserPrimaryPhotoNew_user$key = {
  readonly " $data"?: UserPrimaryPhotoNew_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "dpr",
  "variableName": "dpr"
},
v1 = {
  "kind": "Variable",
  "name": "h",
  "variableName": "imageSize"
},
v2 = {
  "kind": "Variable",
  "name": "w",
  "variableName": "imageSize"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "dpr"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "imageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserPrimaryPhotoNew_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailMd5",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "fields": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "fit",
                  "value": "cover"
                },
                {
                  "kind": "Literal",
                  "name": "fo",
                  "value": "face"
                },
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "kind": "ObjectValue",
              "name": "transform"
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "defaultAvatarUrl",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "69d682972ec8e6251a3075e962184b6b";

export default node;
